// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import FullNameInput from 'ui-addon-i18n/components/FullNameInput';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import AvatarContainer from '../containers/AvatarContainer';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { MultiColumn, MultiColumnGroup, MultiColumnItem } from 'foundations-components/transitional/components/MultiColumn';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class ProfileHeader extends Component {
  render() {
    const {
      stagedFirstName,
      stagedLastName,
      validFirstName,
      validLastName,
      isScimUser,
      isImpersonated
    } = this.props;
    return /*#__PURE__*/_jsx(MultiColumn, {
      flush: true,
      children: /*#__PURE__*/_jsx(MultiColumnGroup, {
        children: /*#__PURE__*/_jsxs(MultiColumnItem, {
          paddingBlockStart: "0",
          children: [/*#__PURE__*/_jsx(FormControl, {
            label: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "userPreferences.profileImage"
            }),
            marginBlockEnd: "600",
            children: /*#__PURE__*/_jsx("div", {
              style: {
                width: '72px'
              },
              children: /*#__PURE__*/_jsx(AvatarContainer, {})
            })
          }), /*#__PURE__*/_jsx(FullNameInput, {
            givenNameInput: /*#__PURE__*/_jsx(FormControl, {
              error: !validFirstName,
              validationMessage: !validFirstName && /*#__PURE__*/_jsx(FormattedMessage, {
                message: "userPreferences.labels.invalidName"
              }),
              labelTooltip: isScimUser && /*#__PURE__*/_jsx(FormattedMessage, {
                message: "userPreferences.errors.notAllowedToEditScimUser"
              }),
              marginBlockEnd: "600",
              children: /*#__PURE__*/_jsx(TextInput, {
                value: stagedFirstName,
                onChange: this.props.onStagedFirstNameChanged,
                readOnly: isScimUser || isImpersonated,
                "data-test-id": "first-name"
              })
            }),
            familyNameInput: /*#__PURE__*/_jsx(FormControl, {
              error: !validLastName,
              validationMessage: !validLastName && /*#__PURE__*/_jsx(FormattedMessage, {
                message: "userPreferences.labels.invalidName"
              }),
              labelTooltip: isScimUser && /*#__PURE__*/_jsx(FormattedMessage, {
                message: "userPreferences.errors.notAllowedToEditScimUser"
              }),
              marginBlockEnd: "600",
              children: /*#__PURE__*/_jsx(TextInput, {
                value: stagedLastName,
                onChange: this.props.onStagedLastNameChanged,
                "data-test-id": "last-name",
                readOnly: isScimUser || isImpersonated
              })
            })
          })]
        })
      })
    });
  }
}
ProfileHeader.propTypes = {
  stagedFirstName: PropTypes.string.isRequired,
  stagedLastName: PropTypes.string.isRequired,
  validFirstName: PropTypes.bool.isRequired,
  validLastName: PropTypes.bool.isRequired,
  onStagedFirstNameChanged: PropTypes.func.isRequired,
  onStagedLastNameChanged: PropTypes.func.isRequired,
  isScimUser: PropTypes.bool.isRequired,
  isImpersonated: PropTypes.bool.isRequired
};
export default ProfileHeader;